<div class="cx-order-summary simple-card">
  <div class="cx-review-summary-card">
    <p class="title m-0 d-flex v-center">
      <span class="material-symbols-outlined icon"> request_quote </span>

      <span class="m-b-0">{{ isOrder ? ('cart.orderCost.orderPricingSummary' | cxTranslate) : ('cart.orderCost.orderSummary' | cxTranslate) }}</span>
    </p>
  </div>

  <div class="cx-summary-partials m-t-20" *ngIf="cart">
    @if (cart.totalWeight) {
      <div class="cx-summary-row">
        <div class="cx-summary-label">{{ 'cart.orderCost.totalWeight' | cxTranslate }}:</div>

        <div class="cx-summary-amount">{{ cart.totalWeight }}</div>
      </div>
    }

    <div class="cx-summary-row">
      <div class="cx-summary-label">{{ 'cart.orderCost.subtotal' | cxTranslate }}</div>

      <div class="cx-summary-amount">{{ cart.subTotal?.formattedValue }}</div>
    </div>

    @if (showDeliveryCoast(cart.deliveryCost?.value)) {
      <div class="cx-summary-row">
        <div class="cx-summary-label">
          {{ (cart.deliveryCost?.formattedValue ? 'cart.orderCost.shipping' : 'cart.orderCost.estimatedShipping') | cxTranslate }}
        </div>

        <div class="cx-summary-amount">
          {{ cart.deliveryCost?.formattedValue ? cart.deliveryCost?.formattedValue : ('cart.orderCost.toBeDetermined' | cxTranslate) }}
        </div>
      </div>
    }

    <div class="cx-summary-row cx-summary-total m-b-20">
      <div class="cx-summary-label">
        {{ 'cart.orderCost.total' | cxTranslate }}
      </div>

      <div class="cx-summary-amount">
        {{ cart.totalPriceWithTax?.formattedValue }}
      </div>
    </div>

    <div *ngIf="!isOrder">
      <cart-free-shipping-message></cart-free-shipping-message>
    </div>
  </div>
</div>
